import type { IMarketingChannelsFilterDto } from "../../../types/leadsSearchFilters.dto";

export const CHANNELS_KEYS: (keyof IMarketingChannelsFilterDto)[] = [
    "searchShare",
    "paidSearchShare",
    "organicSearchShare",
    "directShare",
    "socialShare",
    "organicSocialShare",
    "paidSocialShare",
    "referralsShare",
    "displayAdsShare",
    "emailShare",
    "genAiShare",
    "affiliateShare",
];

export const NEW_CHANNEL_METRICS: ReadonlySet<keyof IMarketingChannelsFilterDto> = new Set([
    "searchShare",
    "organicSocialShare",
    "paidSocialShare",
    "genAiShare",
    "affiliateShare",
]);
